import React, { useState } from 'react';
import styled from '@emotion/styled';

import { copyToClipboard } from 'common/components/CopyText/utils';
import { SubmitButton } from 'common/components/Form/FormSubmitButton';
import { useMatchesViewport } from 'common/hooks/media';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { WhiteSpaceProps } from 'common/theme/system-utilities';
import { whiteSpace } from 'common/theme/system-utilities';
import { captureException } from 'common/utils/error-reporter';
import { TrackingInteraction, trackReferAFriendClick } from './tracking';

const BUTTON_HEIGHT = 48;
const COPY_ICON_SIZE = [24, null, null, 32];

const Button = styled(SubmitButton)<WhiteSpaceProps>`
  ${whiteSpace};
`;

const CopyButton = ({ referralLink, isDisabled, onCopyStart, onCopyEnd }) => {
  const { t } = useLocalization();
  const {
    matches: { matchesDesktop, matchesLargeDesktop },
  } = useMatchesViewport();

  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = async () => {
    try {
      trackReferAFriendClick(t('h24_refer_copy_btn_label'), TrackingInteraction.CopyReferralLink);

      onCopyStart();
      await copyToClipboard(referralLink);
      setIsCopied(true);
      setTimeout(() => {
        onCopyEnd();
        setIsCopied(false);
      }, 3000);
    } catch (error) {
      onCopyEnd();
      captureException(error);
    }
  };

  return (
    <Button
      mb="sp_0"
      iconName="copy"
      whiteSpace="nowrap"
      isSuccess={isCopied}
      onClick={handleCopyClick}
      iconSize={COPY_ICON_SIZE}
      themeHeight={BUTTON_HEIGHT}
      isDisabled={isDisabled}
      successButtonSize={COPY_ICON_SIZE}
      defaultButtonLabel={t('h24_refer_copy_btn_label')}
      successButtonLabel={t('h24_refer_copy_btn_success_label')}
      width={matchesDesktop || matchesLargeDesktop ? '80%' : '100%'}
    />
  );
};

export default CopyButton;
